import { RESTproxy } from '../RESTproxy';
import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

export class TemplatesProxy extends RESTproxy {
    constructor() {
        super('template');
    }

    async remove(id) {
        const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/template/${id}`, {
            method: 'DELETE',
        });
        if (!res.ok && res.status !== 204) throw new Error(res.statusText);
    }
}
